<template>
  <div>
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        产品明细
      </div>
      <div class="rj-page-card__content">
        <div class="miaoshu">
          <div class="tip rj-flex">
            <div>
              注：
            </div>
            <div class="rj-flex__item">
              <p>1、限于本项目的一次性折让优惠.</p>
              <p>2、本报价是贵公司向锐捷网络的提货价格。</p>
              <p>3、订单供货期规则（下单生成时间至要货时间）：仅含中低端产品：7天；高端产品：14天；定制化产品 / 按单产品 / 受控产品：单独与平台商务或供应链沟通确认。</p>
              <p>4、服务主体职责：负责输出项目的方案设计，项目管理，对项目的全过程负责。</p>
              <!-- <p>5、此项目按照2019年渠道政策执行。</p> -->
            </div>
          </div>
          <div v-if="!baseInfo.thisObejctSubject" class="totalMoney">
            总计：{{ Number(totoal).toFixed(2) }}
          </div>
          <p v-if="CustomizationList.length" style="padding: 10px 0;color:red">
            此单涉及定制化产品，具体型号为：
            <el-tag v-for="(item,index) in CustomizationList" :key="index">
              {{ item.productName }}
            </el-tag>
            下单时请代理商支付此合同全部货款的30%进行下单，有疑问，请联系对应销售。
          </p>
        </div>
        <div class="el-table el-table--fit el-table--border el-table--enable-row-transition el-table--mini" style="width: 100%;">
          <div class="el-table__header-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
              <colgroup>
                <col width="40%">
                <col width="60%">
                <col width="120">
                <col width="120">
                <col width="120">
                <col width="120">
              </colgroup>
              <thead class="has-gutter">
                <tr class="">
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      产品分类
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      产品型号
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      产品数量
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      服务授权分类
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class=" is-center is-leaf">
                    <div class="cell">
                      是否购买PSC
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class=" is-center is-leaf">
                    <div class="cell">
                      是否锐捷提供PSC软件调试服务
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="el-table__body-wrapper is-scrolling-none">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
              <colgroup>
                <col width="40%">
                <col width="60%">
                <col width="120">
                <col width="120">
                <col width="120">
                <col width="120">
              </colgroup>
              <tbody>
                <template v-for="(productInfos,index) in tableData">
                  <template v-for="(product,row) in productInfos.productInfos">
                    <tr v-if="!product.productPackage&&!product.cloudDesktopMatching" :key="index+'-'+row" class="el-table__row">
                      <!--不是组合包的情况-->
                      <td class="is-center ">
                        <div class="cell">
                          {{ product.productCategoryName }}
                        </div>
                      </td>
                      <td class="is-center ">
                        <div class="cell">
                          {{ product.productName }}
                        </div>
                      </td>
                      <td class="is-center ">
                        <div class="cell">
                          {{ product.productAmount }}
                        </div>
                      </td>
                      <td class="is-center ">
                        <div class="cell">
                          {{ product.productPscType }}
                        </div>
                      </td>
                      <td class="is-center ">
                        <div class="cell">
                          {{ product.buyPsc=='true'?'是':'否' }}
                        </div>
                      </td>
                      <td class="is-center ">
                        <div class="cell">
                          {{ product.rjyuPsc=='true'?'是':'否' }}
                        </div>
                      </td>
                    </tr>
                    <template v-else-if="!product.cloudDesktopMatching">
                      <!--组合包表格UI 数据循环逻辑待定-->
                      <tr v-for="(packmain,clomain) in product.productPackages" :key="index+'-'+row+'-pack-' +clomain" class="el-table__row">
                        <td class="is-center ">
                          <div class="cell">
                            {{ product.productCategoryName }}
                          </div>
                        </td>
                        <td v-if="clomain==0" :rowspan="product.productPackages.length" style="padding: 0;position:relative;">
                          <table width="100%" height="100%" class="groupTable">
                            <tr v-for="(pack,clo) in product.productPackages" :key="index+'-'+row+'-' +0+'-'+clo">
                              <td v-if="clo==0" class="is-center" :rowspan="product.productPackages.length">
                                {{ product.productName }}
                              </td>
                              <td class=" borderBottom is-center">
                                {{ pack.productName }}
                              </td>
                            </tr>
                          </table>
                          <div class="groupTableline" />
                        </td>
                        <td v-if="clomain==0" class="is-center " :rowspan="product.productPackages.length">
                          <div class="cell">
                            {{ product.productAmount }}
                          </div>
                        </td>
                        <td class="is-center ">
                          <div class="cell">
                            {{ packmain.productPscType }}
                          </div>
                        </td>
                        <td v-if="clomain==0" class="is-center " :rowspan="product.productPackages.length">
                          <div class="cell">
                            {{ product.buyPsc=='true'?'是':'否' }}
                          </div>
                        </td>
                        <td v-if="clomain==0" class="is-center " :rowspan="product.productPackages.length">
                          <div class="cell">
                            {{ product.rjyuPsc=='true'?'是':'否' }}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <clod-product v-if="cloudDeskTable.length" :table-data="cloudDeskTable" />
  </div>
</template>
<script type="es6">
import { getOrderProductInfo } from '@/API/index';
import clodProduct from './clodProduct';
export default {
  data () {
    return {
      loading: false,
      tableData: [],
      totoal: 0
    };
  },
  props: {
    // 数据由父组件传递
    documentID: {
      type: String,
      required: true
    },
    baseInfo: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    clodProduct
  },
  computed: {
    // 定制化产品
    CustomizationList () {
      let table = [];
      this.tableData.forEach((productInfos) => {
        productInfos.productInfos.forEach((pro) => {
          pro.customizationOrNot && (table.push(pro));
        });
      });
      return table;
    },
    cloudDeskTable () {
      let table = [];
      this.tableData.forEach((productInfos) => {
        productInfos.productInfos.forEach((pro) => {
          if (pro.cloudDesktopMatching && pro.productType === 'host') {
            table.push(pro);
          }
        });
      });
      return table;
    }
  },
  methods: {
    initData () {
      this.loading = true;
      let params = {
        documentID: this.documentID,
        newEcpFlag: this.$route.query.newEcpFlag
      };
      getOrderProductInfo(params).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData = json.data.productCategorys;
          this.totoal = json.data.integratorsTotal;
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
  @import "../../../../style/var";
  .miaoshu{
    line-height: 30px;
    .totalMoney{
      color: $--color-danger;
      font-size: 15px;
    }
    .tip{
      color: $--color-text-secondary;
      font-size: 13px;
    }
  }
.proTitle{
  font-size: 15px;
  .label{
    display: inline-block;
  }
  .money{
    color: $--color-danger;
    display: inline-block;
    margin-left: 25px;
  }
}
  .productTable{
    &.el-table::before{
      height: 0;
    }
    tr{
      td{
        border-right: 1px solid $--border-color-light;
        border-bottom: 1px solid $--border-color-light;
        &:last-child{
          border-right:none;
        }
      }
      &:last-child{
        td{
          border-bottom: none;
        }
      }
    }
  }
  .groupTable{
    table-layout: fixed;
    border-collapse: collapse;
    tr{
      td{
        padding: 10px 0;
        border: none;
        &.borderBottom{
          border-bottom: 1px solid $--border-color-light;
        }
      }
      &:last-child{
        td{
          &.borderBottom{
            border: none;
          }
        }
      }
    }
  }
  .groupTableline{
    position: absolute;
    width: 1px;
    height: 100%;
    background: $--border-color-light;
    top: 0;
    left: 50%;
  }
</style>
